import * as ReactDOM from 'react-dom';
import Main from './components/Main';
import { configure } from 'mobx';

configure({
  enforceActions: 'never',
});
ReactDOM.render(<Main />, document.getElementById('base'));
